export default __webpack_public_path__ + "static/media/office1-before1-768w.4b105c2a.avif";